import { Injectable, inject } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { SiteState } from '@next/core-lib/site';
import { UserActions } from '@next/core-lib/user';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concatMap, finalize, map, mergeMap, startWith } from 'rxjs/operators';

import * as CropsActions from './crops/crops.actions';
import * as IngredientsActions from './ingredients/ingredients.actions';
import { CropService } from '../shared/services/crop.service';
import { IngredientsService } from '../shared/services/ingredients.service';

@Injectable()
export class AppEffects {
  private readonly actions$ = inject(Actions);
  private readonly cropService = inject(CropService);
  private readonly ingredientService = inject(IngredientsService);
  private readonly store = inject<Store<SiteState>>(Store);

  userInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.userInitialized),
      concatMap((_) => [
        CropsActions.loadCropsRequest(),
        IngredientsActions.loadIngredientsRequest(),
      ]),
    ),
  );

  loadCrops$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CropsActions.loadCropsRequest),
      mergeMap(() =>
        this.cropService.getCrops().pipe(
          map((crops) => CropsActions.loadCropsSuccess({ crops })),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );

  loadIngredients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IngredientsActions.loadIngredientsRequest),
      mergeMap(() =>
        this.ingredientService.getIngredients().pipe(
          map((ingredients) => IngredientsActions.loadIngredientsSuccess({ ingredients })),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
}
